import React from "react";

import { baseApiUrl } from "../General/Constants";

function NotFound() {
  return (
    <>
      <h1 style={{ textAlign: "center", marginTop: "100px" }}>
        404 - Cadastro não encontrado :(
      </h1>
      <h3 style={{ textAlign: "center" }}>
        A url <span>{baseApiUrl}</span> não existe
      </h3>
    </>
  );
}

export default NotFound;
